<form
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  [attr.data-testid]="'prompt-dialog-form'"
  >
  <div class="container">
    <p [attr.data-testid]="'prompt-dialog-title'">{{ title }}</p>
    <mat-form-field legacyAppearance>
      @if (placeholder) {
        <mat-label
          [attr.data-testid]="'prompt-dialog-input-label'"
          >{{ placeholder }}</mat-label
          >
        }
        <input
          matInput
          formControlName="value"
          [attr.data-testid]="'prompt-dialog-input'"
          />
        <mat-error class="w-full text-xs" [attr.data-testid]="'prompt-dialog-error'">
          @for (error of extraValidatorError; track error) {
            @if (
              valueInputControl.errors && valueInputControl.errors[error.name]
              ) {
              {{ error.text }}
            }
          }
        </mat-error>
      </mat-form-field>
    </div>
    <button
      class="!rounded-none"
      mat-raised-button
      type="submit"
      color="primary"
      [disabled]="form.invalid"
      [attr.data-testid]="'prompt-dialog-submit-button'"
      >
      {{ confirm }}
    </button>
  </form>
